module.exports = __webpack_public_path__ + "img/rectangle-checked.3906fca6.svg";